import { EventEmitter } from '@angular/core';

import { Directive, ElementRef, HostListener, Input, Output } from '@angular/core';
@Directive({
    selector: '[appOnEnter]'
})
export class OnEnterDirective {

    @Output() enterPressed = new EventEmitter();

   // USO : <div appOnEnter (enterPressed)=do()></div>
    @HostListener('keydown', ['$event']) onKeyDown(e) {
        if ((e.which === 13 || e.keyCode === 13)) {
            console.log('ENTER PRESSED');
            this.enterPressed.emit();
        }

    }

}
